<template>
  <div class="diagnose">
    <el-dialog
      title="回访"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      style="margin-top: 100px"
    >
      <el-form :model="diagnoseFormData" label-width="100px">
        <el-form-item label="电话接通情况">
          <el-select
            v-model="diagnoseFormData.followupPhone"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in phoneOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="患者依从性">
          <el-select
            v-model="diagnoseFormData.followupObey"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in obeyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="患者意向">
          <el-radio-group v-model="isfollow" size="medium">
            <el-radio label="愿意遵从医嘱进行门诊或住院治疗"></el-radio>
            <el-radio label="不愿遵从"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="不愿遵从原因">
          <el-input
            type="textarea"
            v-model="diagnoseFormData.followupSubjective"
            placeholder="不愿遵从及原因"
            :disabled="getDealType()"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >关闭</el-button
        >
        <el-button type="primary" @click="submitRecord">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { addFollowupCodiag } from "@/api/health/Patients";

Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
export default {
  data() {
    return {
      dialogVisible: false,
      diagnoseFormData: {
        id: null,
        followupFlag: null,
        followupPhone: null,
        followupObey: null,
        followupSubjective: null,
      },
      isfollow: "",
      patientMsg: null,
      phoneOptions: [
        {
          text: "已接听",
          value: "已接听",
        },
        {
          text: "空号",
          value: "空号",
        },
        {
          text: "停机",
          value: "停机",
        },
        {
          text: "未接听",
          value: "未接听",
        },
      ],
      obeyOptions: [
        {
          text: "配合",
          value: "配合",
        },
        {
          text: "不配合",
          value: "不配合",
        },
      ],
    };
  },
  created() {},
  methods: {
    // 初始化组件
    async init(value) {
      console.log("患者处置信息", value);
      this.patientMsg = value;
      this.diagnoseFormData = {
        id: null,
        followupFlag: null,
        followupPhone: null,
        followupObey: null,
        followupSubjective: null,
      };
      this.isfollow = "";
      this.dialogVisible = true;
    },
    getDealType() {
      if (this.isfollow == "不愿遵从") {
        return false;
      } else {
        return true;
      }
    },
    // 一键转诊
    submitRecord() {
      if (!this.diagnoseFormData.followupPhone) {
        this.$message({
          message: "请选择电话接通情况！",
          type: "error",
        });
        return;
      }

      if (this.diagnoseFormData.followupPhone == "已接听") {
        if (!this.diagnoseFormData.followupObey) {
          this.$message({
            message: "请选择患者依从性！",
            type: "error",
          });
          return;
        }

        if (this.isfollow == "") {
          this.$message({
            message: "请选择患者意向！",
            type: "error",
          });
          return;
        }

        if (
          this.isfollow == "不愿遵从" &&
          !this.diagnoseFormData.followupSubjective
        ) {
          this.$message({
            message: "请输入不愿意遵从原因！",
            type: "error",
          });
          return;
        }

        if (this.isfollow == "愿意遵从医嘱进行门诊或住院治疗") {
          this.diagnoseFormData.followupSubjective = this.isfollow;
        }else{
          this.diagnoseFormData.followupSubjective = "不愿意遵从，" + this.diagnoseFormData.followupSubjective;
        }
      }

      this.diagnoseFormData.id = this.patientMsg.id;
      this.diagnoseFormData.followupFlag = "1";

      console.log("diagnoseFormData", this.diagnoseFormData);
      addFollowupCodiag(this.diagnoseFormData).then((res) => {
        if (res.msg == "success") {
          this.$message({
            message: "提交成功!",
            type: "success",
          });
          this.$emit("updateCoRecordList");
          this.dialogVisible = false;
        } else {
          this.$message({
            message: "提交失败!",
            type: "error",
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    margin-top: 5vh !important;
  }
}
</style>